import React, { FC } from 'react';
import { Switch } from 'antd';
import { Field, UseFieldConfig } from 'react-final-form';

interface IProps {
  name: string;
  useFieldConfig?: UseFieldConfig<boolean>;
}

const FormAntSwitch: FC<IProps> = ({ name, useFieldConfig }) => (
  <Field name={name} type="checkbox" {...useFieldConfig}>
    {({ input }) => (
      <span
        onClick={event => event.stopPropagation()}
        onMouseDown={event => event.stopPropagation()}
      >
        <Switch
          checked={Boolean(input.checked)}
          onChange={checked =>
            input.onChange({
              target: {
                type: 'checkbox',
                checked
              }
            })
          }
        />
      </span>
    )}
  </Field>
);

export default FormAntSwitch;
